export enum CollectionNamespaces {
  GlobalUsers = 'globalUsers',
  Groups = 'groups',
  Vendors = 'vendors',
  Materials = 'materials',
  Clients = 'clients',
  Users = 'users',
  Bids = 'bids',
  AppDefaults = 'appDefaults',
  Trucks = 'trucks',
  UserSettings = 'userSettings'
}
